import ErrorPage from '../errors/ErrorPage';
import ProgressReportPortuguese from './report-languages/ProgressReportPortuguese';
import ProgressReportSpanish from './report-languages/ProgressReportSpanish';

type PropsT = {
    language: any
}

const ProgressReport = ({language}:PropsT) => {

    switch(language){
        case 'es': return <ProgressReportSpanish />
        case 'pt': return <ProgressReportPortuguese />
        default: return <ErrorPage />
    }
}

export default ProgressReport
